module.exports = __webpack_public_path__ + "865c45c00cd937337aebaed7839799e6.svg";